import { MessageProcessor } from '../websocketProcessorTypes'
import store from '../../redux/store'
import {
  updateStudentDecisions,
  updateAdjudication,
  setDecisions,
} from '../../redux/slices/studentDecisionWebsocketSlice'
import {
  ResearchDecisionOptionsPayload,
  ResearchOptionsStatus,
  setResearchDecisionOptions,
} from '../../redux/slices/researchModeSlice'
import { UserRole } from '@/constants/room'

const EXPECTED_RESEARCH_OPTIONS_COUNT = 3

const normalizeResearchOptionsPayload = (
  payload: any
): ResearchDecisionOptionsPayload | null => {
  const phaseId = Number(payload?.phase_id)
  const studentId = Number(payload?.student_id)
  if (
    !payload ||
    Number.isNaN(phaseId) ||
    Number.isNaN(studentId)
  ) {
    return null
  }
  const status: ResearchOptionsStatus =
    payload.status === ResearchOptionsStatus.PENDING ||
    payload.status === ResearchOptionsStatus.READY ||
    payload.status === ResearchOptionsStatus.FAILED
      ? payload.status
      : ResearchOptionsStatus.FAILED
  const options = Array.isArray(payload.options)
    ? payload.options.filter((option: unknown): option is string => typeof option === 'string')
    : []
  const normalized: ResearchDecisionOptionsPayload = {
    phase_id: phaseId,
    student_id: studentId,
    options,
    status,
    error_message:
      typeof payload.error_message === 'string' ? payload.error_message : null,
  }
  if (
    normalized.status === ResearchOptionsStatus.READY &&
    normalized.options.length !== EXPECTED_RESEARCH_OPTIONS_COUNT
  ) {
    return {
      ...normalized,
      status: ResearchOptionsStatus.FAILED,
      options: [],
      error_message:
        normalized.error_message ||
        'Received an invalid set of decision options. Please retry.',
    }
  }
  return normalized
}

export const studentDecisionProcessors: MessageProcessor[] = [
  {
    type: 'decision_submitted',
    handler: (data) => {
      store.dispatch(updateStudentDecisions(data.payload))
    },
  },
  {
    type: 'adjudication_added',
    handler: (data) => {
      store.dispatch(updateAdjudication(data.payload))
    },
  },
  {
    type: 'bulk_adjudications_added',
    handler: (data) => {
      if (data.adjudications && Array.isArray(data.adjudications)) {
        data.adjudications.forEach((adjudication: any) => {
          store.dispatch(updateAdjudication(adjudication))
        })
      }
    },
  },
  {
    type: 'populate_decisions',
    handler: (data) => {
      store.dispatch(setDecisions(data.decisions))
    },
  },
  {
    type: 'research_decision_options',
    handler: (data) => {
      const payload = normalizeResearchOptionsPayload(data.payload)
      if (!payload?.student_id) return
      const u = store.getState().user.user
      if (
        u?.role === UserRole.Student &&
        Number(payload.student_id) !== Number(u.id)
      ) {
        return
      }
      store.dispatch(setResearchDecisionOptions(payload))
    },
  },
]
